import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";

import "./MobileMenu.css";

const MobileMenu = ({ selectedBusiness, onLogout, onClose, hamburgerRef }) => {
  const businessId = selectedBusiness?.id;
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedOutsideMenu = menuRef.current && !menuRef.current.contains(event.target);
      const clickedHamburger = hamburgerRef?.current?.contains(event.target);

      if (clickedOutsideMenu && !clickedHamburger) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose, hamburgerRef]);


  useEffect(() => {
  // enables :active styles in iOS Safari
  const noop = () => {};
  document.addEventListener('touchstart', noop, { passive: true });
  return () => document.removeEventListener('touchstart', noop);
}, []);


  return (
    <div className="mobile-menu-container" ref={menuRef}>
      <ul>
        {businessId && (
          <>

          <li>
          <Link to="/dashboard/business/user/profile" onClick={onClose}>Home</Link>
        </li>
            <li>
              <Link to={`/dashboard/business/${businessId}`} onClick={onClose}>Business Page</Link>
            </li>
            <li>
              <Link to={`/dashboard/business/employees`} onClick={onClose}>Employees</Link>
            </li>
            <li>
              <Link to={`/dashboard/business/${businessId}/viewpayroll`} onClick={onClose}>Payroll</Link>
            </li>
            <li>
              <Link to={`/dashboard/business/${businessId}/check-write`} onClick={onClose}>Check Writer</Link>
            </li>
            <li>
              <Link to={`/dashboard/business/${businessId}/invoicing`} onClick={onClose}>Invoice</Link>
            </li>
            <li>
              <Link to={`/dashboard/business/${businessId}/accounting`} onClick={onClose}>Accounting</Link>
            </li>
            <li>
              <Link to={`/dashboard/business/${businessId}/cash-in`} onClick={onClose}>Cash In</Link>
            </li>
            
          </>
        )}
      
        <li>
          <button className="logout-btn-mobile" onClick={onLogout}>Logout</button>
        </li>
      </ul>
    </div>
  );
};

export default MobileMenu;

